import axios from "axios";
import { browserHistory } from "react-router";
import { userMayLogin } from "../utils/auth";
import { setMfaSetupContext } from "../utils/mfaSetupContext";
import { markSkipNextAuthRecheck } from "../utils/authSession";

export const errorMessages = {
  login_failed: "Inloggen mislukt. Neem contact op met NIBHV: 010-2892888",
  invalid_role: "U heeft geen toegang tot deze applicatie.",
  blocked: "Oeps! Je account lijkt geblokkeerd. Neem contact op met NIBHV: 010-2892888",
  unknown_error: "Oeps! Er is een technische fout opgetreden. Neem contact op met NIBHV als het probleem zich blijft voordoen: 010-2892888"
};

export function getApiMessage(data, fallback) {
  if (!fallback) {
    fallback = errorMessages.unknown_error;
  }

  if (data && typeof data.detail === "string" && data.detail.trim()) {
    return data.detail;
  }

  if (data && Array.isArray(data.non_field_errors) && data.non_field_errors.length > 0) {
    return data.non_field_errors[0];
  }

  return fallback;
}

export function handleRequiredMfaSetup(params) {
  const data = params && params.data;
  const redirectTo = (params && params.redirectTo) || "/events";

  if (!data || data.code !== "mfa_setup_required" || !data.mfa_setup_ticket) {
    return false;
  }

  setMfaSetupContext({
    required: true,
    prompt: false,
    ticket: data.mfa_setup_ticket,
    redirectTo: redirectTo
  });
  browserHistory.push("/mfa/setup");
  return true;
}

export async function finalizeLogin(params) {
  const data = params && params.data;
  const setUserData = params && params.setUserData;
  const setAuthToken = params && params.setAuthToken;
  const redirectTo = (params && params.redirectTo) || "/events";

  let user = data && data.user;
  if (!user) {
    const meResponse = await axios.get("/v2/auth/me/", {
      skipAuthFailure: true,
      skipAuthRefresh: true,
      skipAuthToken: true,
      validateStatus: (status) => status >= 200 && status < 300
    });
    user = meResponse.data;
  }

  const loginCheck = userMayLogin(user);
  const mayLogin = loginCheck[0];
  const errorCode = loginCheck[1];

  if (!mayLogin) {
    return { success: false, errorCode: errorCode };
  }

  setUserData(user);
  setAuthToken();

  if (data && data.mfa_setup_ticket) {
    setMfaSetupContext({
      required: false,
      prompt: true,
      ticket: data.mfa_setup_ticket,
      mfaRequiredAfter: data.mfa_required_after || null,
      redirectTo: redirectTo
    });
    browserHistory.push("/mfa/setup");
    return { success: true };
  }

  markSkipNextAuthRecheck();
  browserHistory.push(redirectTo);
  return { success: true };
}



// WEBPACK FOOTER //
// ./pages/loginFlowUtils.js